// The time left before a layer resets, at the right end of the WEEKLY and
// MONTHLY rules (Aaron 2026-11-02): whole days while more than 48 hours
// remain, then hh:mm:ss. It draws the rule's right half, the line then the
// time, so the label stays centred. A reset already past (a past night's week
// or month) shows the line alone.
import { useEffect, useState } from 'react';
import { formatTimeLeft, serverNow } from '../../systems/clock/serverClock';

/** The server's time, ticking once a second. */
export function useServerNow(): number {
  const [now, setNow] = useState(() => serverNow());
  useEffect(() => {
    const t = setInterval(() => setNow(serverNow()), 1000);
    return () => clearInterval(t);
  }, []);
  return now;
}

export function ResetTimer({ resetAt, title }: { resetAt: number; title: string }) {
  const now = useServerNow();
  return (
    <span className="layer-divider-end">
      {resetAt > now && (
        <span className="label-mono layer-timer" title={title}>
          {formatTimeLeft(resetAt - now)}
        </span>
      )}
    </span>
  );
}
